export default ({ store, redirect }) => {
  if (store.state.cart.cart.length === 0) {
    redirect('/')
  }
}
